import React from 'react';
import {ServerNotificationProps} from '../ServerNotification';
import {INotificationProps} from '@src/@interfaces/components/Notifications/INotificationProps';
import app from '@src/helpers/app';
import OrderStatusRepresentation from '@src/components/StatusRepresentations/OrderStatusRepresentation';
import InfoNotification from '../../InfoNotification';
import makeUrl from '@src/components/Notifications/server-notifications/makeUrl';
import getDashboardEndpoint from '@src/components/Notifications/server-notifications/Order/getDashboardEndpoint';

export default class StatusChanged extends InfoNotification<
        ServerNotificationProps<'App\\Notifications\\Order\\StatusChanged'> &
        INotificationProps
> {
    protected getWrapperTagProps(): any {
        const payload = this.props.notification.data;
        const namesResolver = app('names-resolver').clientRoutes;

        return {
            ...super.getWrapperTagProps(),
            to: makeUrl({
                uriItems: [
                    getDashboardEndpoint('manager-order-page', payload.orderId),
                    {
                        route: namesResolver.getShowRouteName('Orders'),
                        params: {id: String(payload.orderId)},
                    }
                ],
            }),
        };
    }

    protected getDescriptionReplacements() {
        const data = this.props.notification.data;
        const getStatus = (status?: typeof data['was']) => {
            return !status ? '—' : <OrderStatusRepresentation
                    label={status.title}
                    bgColor={status.bg_color}
                    textColor={status.text_color}
            />;
        };


        return {
            ...data,
            oldStatus: getStatus(data.was),
            newStatus: getStatus(data.became),
        };
    }
}
